__turbopack_context__.v({
  "bloque": "adscripcionPildora-module__RB8t6W__bloque",
  "encabezado": "adscripcionPildora-module__RB8t6W__encabezado",
  "pildora": "adscripcionPildora-module__RB8t6W__pildora",
  "puntos": "adscripcionPildora-module__RB8t6W__puntos",
  "rotulo": "adscripcionPildora-module__RB8t6W__rotulo",
  "tooltip": "adscripcionPildora-module__RB8t6W__tooltip",
});
